export const DE = {
  "Open document": "Dokument Ã¶ffnen",
  "Upload file": "Datei hochladen",
  "Drop file here to upload": "Datei zum Hochladen hier ablegen",
  "Disc": "Rabatt",
  "URL": "URL",
  "FILE": "DATEI",
  "SIZE": "GRÃSSE",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Bytes",
  "Loading... Please wait.": "Laden, bitte warten.",
  "Fit Width": "Breite anpassen",
  "Fit Height": "Passende HÃ¶he",
  "Password protected document": "PasswortgeschÃ¼tztes Dokument",
  "Password": "Passwort",
  "Open": "Offen",
  "Password Required": "Passwort erforderlich",
  "Incorrect password": "Falsches Passwort",
  "Error": "Fehler",
  "Something went wrong": "Etwas ist schief gelaufen",
  "Server is not available": "Server nicht verfÃ¼gbar",
  "of": "von",
  "Please wait...": "Warten Sie mal..."
};
